export function PublicVerdictBanner() {
  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 90,
        background: "var(--charcoal)",
        padding: "10px 16px",
        textAlign: "center",
        fontFamily: '"DM Mono", monospace',
        fontSize: 10,
        color: "var(--ivory)",
        letterSpacing: "3px",
        textTransform: "uppercase",
      }}
    >
      Verdict partagé par le Président · Lecture seule · Volume MMXXVI
    </div>
  );
}
